import React from "react";
import {
  Row,
  Column,
  FormGroup,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import { useEffect } from "react";

const AvailabilityForm = ({ disabled, register, errors, candidature }) => {
  useEffect(() => {}, [candidature]);
  return (
    <FormGroup legendText="FORMAÇÃO" className="section-header">
      <fieldset className="bx--fieldset">
        <legend className="bx--label required">
          19. Estás disponível para ter formação noutra zona fora da tua zona de
          residência?
        </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <RadioButtonGroup
              name="isAvailableForTrainingOutsideOfResidence"
              disabled={disabled}
              valueSelected={candidature?.isAvailableForTrainingOutsideOfResidence?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="available-y"
                {...register("isAvailableForTrainingOutsideOfResidence")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="available-n"
                {...register("isAvailableForTrainingOutsideOfResidence")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.isAvailableForTrainingOutsideOfResidence?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

AvailabilityForm.defaultProps = {
  disabled: false,
};

export default AvailabilityForm;
